import { SVGProps } from "react";

export const HopeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.8262 12.1181L7.6123 20.5713M18.5641 9.30036L20.3894 7.42188M13.0882 9.30036L11.2629 7.42188M20.3894 16.8143L18.5641 14.9358M15.8262 8.36112V7.42188M15.8262 17.7535V16.8143M19.4767 12.1181H20.3894M10.3503 12.1181H11.2629"
      fill="none"
      strokeWidth="1.87848"
      strokeLinecap="round"
    />
  </svg>
);
